import apiService from "../common/commonApi";

export const checkExportInquiryService = {};

checkExportInquiryService.get = async (param) => {
    return apiService.Get("inquirydata-check-export", param);
};
